import {
    MDBCard,
    MDBCardFooter,
    MDBCardHeader,
    MDBCardText,
    MDBCol,
    MDBRow,
} from "mdb-react-ui-kit";
import { FC, useState } from "react";
import Image from "next/image";
import { ReviewReadableTO } from "@/models/common/common";
import { starsArray } from "@/utils/star-utils";
import styles from "../../../styles/home/Home.CardReview.module.scss";
import contactsSvg from "../../../utils/svg-icon/contacts";

const CardReview: FC<{
    content: ReviewReadableTO;
    hideStars?: boolean;
    removeLeftMargin?: boolean;
}> = ({ content, hideStars = false, removeLeftMargin = false }) => {
    const { Quote } = contactsSvg;
    const [avatarError, setAvatarError] = useState(false);

    return (
        <MDBCard
            alignment="center"
            className={`${styles.container} ${
                removeLeftMargin ? "ms-0 ms-lg-0" : "mx-2 mx-lg-4"
            }`}
        >
            <MDBCardHeader className="text-start fw-bold">
                {!hideStars && (
                    <MDBCol
                        className={`${styles.textComment} d-flex justify-content-start align-items-center mb-3 p-3 pt-1 pb-0`}
                    >
                        {starsArray(content.rate)}

                        <MDBCardText className="d-flex m-0 fw-bold">
                            {Number(content.rate)}
                        </MDBCardText>
                    </MDBCol>
                )}
                <MDBRow className="d-flex justify-content-end px-2">
                    <MDBCol size={2} className={styles.quotes}>
                        <Quote />
                    </MDBCol>
                </MDBRow>
                <MDBRow className={`${styles.textComment} p-3 pt-1 pb-0`}>
                    <MDBCol size={12}>{content.body}</MDBCol>
                </MDBRow>
            </MDBCardHeader>
            <MDBCardFooter className="d-flex flex-grow-1 mx-2 mx-lg-3">
                <MDBRow className="p-3 ps-0 d-flex align-items-center">
                    <div className={styles.footerContent}>
                        <div className={styles.image_outer_container}>
                            <div className={styles.image_inner_container}>
                                <div className="position-relative h-100">
                                    <Image
                                        className="object-cover h-100"
                                        src={
                                            avatarError
                                                ? "/images/tours/across-italy-reduced.jpg"
                                                : content.image
                                        }
                                        alt="avatar-image"
                                        fill
                                        sizes="(max-width: 768px) 80px, 100px"
                                        quality={60}
                                        loading="lazy"
                                        onError={() => {
                                            setAvatarError(true);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={styles.textWrapper}>
                            <MDBRow className={`${styles.textName} text-start`}>
                                {content.user}
                            </MDBRow>
                            <MDBRow className={`${styles.textWork} text-start`}>
                                {content.title}
                            </MDBRow>
                        </div>
                    </div>
                </MDBRow>
            </MDBCardFooter>
        </MDBCard>
    );
};

export default CardReview;
